import styled from "styled-components";
import { useSeller } from "../../context/seller";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import SellerService from "../../services/seller.service";
import Profile from "../../components/sellers/Me/Profile";
import Sidebar from "../../components/sellers/Me/Sidebar";
import Info from "../../components/sellers/Me/Info";
import Health from "../../components/sellers/Me/Health";
import { mobile } from "../../styles/responsive";
import Payments from "../../components/sellers/Me/Payments";
// modals
import ViewPayments from "../../components/sellers/modals/ViewPayments";
import ViewReservationData from "../../components/sellers/modals/ViewReservationData";
import CreatePayment from "../../components/sellers/modals/CreatePayment";
import AddReservationGroup from "../../components/sellers/modals/AddReservationGroup";
import TicketPaymentGroup from "../../components/sellers/modals/TicketPaymentGroup";
import ConfirmBoucher from "../../components/sellers/modals/ConfirmBoucher";
import Summary from "../../components/sellers/modals/Summary";
import AddReservation from "../../components/sellers/modals/AddReservation";
import TicketPayment from "../../components/sellers/modals/TicketPayment";


export default function Me() {
    const {sellerInfo, setSellerInfo, sellerTab, viewPaymentsData, 
        reservationData, isCreatePaymentModalOpen,
        newGroup,
        isTicketPaymentGroupModalOpen,
        isConfirmBoucherModalOpen,
        isSummaryModalOpen,
        newPassenger,
        isTicketPaymentModalOpen
    } = useSeller()
    const navigate = useNavigate()
    function back() {
        navigate('/seller')
    }
    useEffect(() => {
        async function me() {
            try {
                const response = await (await SellerService.me()).data
                setSellerInfo(response)
            } catch (error) {
                console.log(error)
            }
        }
        me()
    }, [])
    console.log(sellerInfo)
    return (
        <Main>
            <Navbar>
                <button onClick={back}>
                    <IoMdArrowRoundBack/>
                </button>
            </Navbar>
            <Left>
                <Profile/>
                <Sidebar/>
            </Left>
            <Right>
                {
                    sellerTab === 'profile' &&
                    <Info/>
                }
                {
                    sellerTab === 'health' &&
                    <Health/>
                }
                {
                    sellerTab === 'payments' &&
                    <Payments/>
                }
            </Right>
            {
                newPassenger &&
                <AddReservation/>
            }
            {
                isTicketPaymentModalOpen &&
                <TicketPayment/>
            }
            {
                reservationData?.type &&
                <ViewReservationData/>
            }
            {
                viewPaymentsData &&
                <ViewPayments/>
            }
            {
                isCreatePaymentModalOpen &&
                <CreatePayment/>
            }
            {
                newGroup.length > 0 &&
                <AddReservationGroup/>
            }
            {
                isTicketPaymentGroupModalOpen &&
                <TicketPaymentGroup/>
            }
            {
                isConfirmBoucherModalOpen &&
                <ConfirmBoucher/>
            }
            {
                isSummaryModalOpen &&
                <Summary/>
            }
        </Main>
    )
}

const Main = styled.div`
display: grid;
width: 80%;
margin: auto;
min-height: 100dvh;
padding-bottom: 5vh;
grid-template-columns: 1fr 1fr 1fr;
/* grid-template-rows: 70px 1fr 1fr; */
/* ${mobile({
    width: '90%'
})} */
`

const Navbar = styled.div`
grid-column: 1 / -1;
padding: 20px 0;
button {
    height: 30px;
    width: 30px;
    background-color: rgba(0,0,0,0);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
}
`

const Left = styled.div`
grid-column: 1 / span 1;
${mobile({
    gridColumn: '1 / -1',
    gridRow: '2 / span 1'
})}
`
const Right = styled.div`
grid-column: 2 / -1;
${mobile({
    gridColumn: '1 / -1',
    gridRow: '3 / span 1'
})}
`